import { api } from "./rtkAPI";
import { lhwpath } from "../apiRoutes";
import { PlaceOrderRequest, PlaceOrderResponse } from "../../types/ordering";

/**
 * Website ordering — lhw `global/webOrder` module (docs/ORDERING-API-CONTRACT.md).
 *   POST /global/order               -> PlaceOrderResponse (201) | 409 QUOTE_STALE
 *   GET  /global/order/mine          -> { success, count, orders[] }
 *   GET  /global/order/:orderNumber  -> { success, salesOrder: { salesOrderData, items } }
 * Teeno par contractor login zaroori hai (JWT header rtkAPI khud lagata hai).
 */
export interface MyOrderRow {
  orderNumber: string;
  createdAt: string;
  status: string;
  approvalPending: boolean;
  itemCount: number;
  grandTotal: number;
}

export interface MyOrdersResponse {
  success: boolean;
  count: number;
  orders: MyOrderRow[];
}

export interface OrderItemRow {
  item?: {
    _id?: string;
    name?: string;
    code?: string;
    images?: string[] | string;
    cid?: { name?: string } | string;
    commonUnit?: { unitId?: { name?: string } | string }[] | any;
  } | string;
  company?: string;
  /** backend add karega (reorder ke liye) — na ho to reorder button nahi dikhta */
  companyProductId?: string;
  companyName?: string;
  godown?: { godownName?: string } | string;
  unit?: string;
  quantity: number;
  taxableValue: number;
  gst: number;
  bill?: boolean;
}

export interface OrderDetailResponse {
  success: boolean;
  salesOrder: {
    salesOrderData: {
      orderNumber: string;
      createdAt: string;
      status?: string;
      total?: number;
      remark?: string;
      PoNumber?: string;
      webApproval?: string;
      shippingAddressDeatils?: {
        city?: string;
        contactPerson?: string;
        contactPersonPhoneNo?: number | string;
        state?: string;
        pinCode?: string;
        address?: string;
      };
      customer?: { customerName?: string; customerCode?: string; gstNumber?: string; phoneNumber?: string };
      item?: OrderItemRow[];
    };
    items: OrderItemRow[];
  };
}

export const WebOrderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    placeOrder: builder.mutation<PlaceOrderResponse, PlaceOrderRequest>({
      query: (body) => ({ url: `${lhwpath}/global/order`, method: "POST", body }),
    }),
    myOrders: builder.query<MyOrdersResponse, { page?: number; limit?: number } | void>({
      query: (arg) => {
        const page = (arg && arg.page) || 1;
        const limit = (arg && arg.limit) || 20;
        return { url: `${lhwpath}/global/order/mine?page=${page}&limit=${limit}`, method: "GET" };
      },
    }),
    myOrder: builder.query<OrderDetailResponse, string>({
      query: (orderNumber) => ({
        url: `${lhwpath}/global/order/${encodeURIComponent(orderNumber)}`,
        method: "GET",
      }),
    }),
  }),
});

export const { usePlaceOrderMutation, useMyOrdersQuery, useMyOrderQuery } = WebOrderApi;

/** Order status -> tracker step (0..3) + label + tone */
export const orderStep = (
  status?: string,
  approvalPending?: boolean
): { step: number; label: string; tone: "ok" | "warn" | "navy" | "muted" } => {
  const s = String(status || "").toLowerCase();
  if (approvalPending) return { step: 1, label: "Approval pending", tone: "warn" };
  if (s.includes("cancel") || s.includes("reject")) return { step: 0, label: "Cancelled", tone: "muted" };
  if (s.includes("deliver") || s.includes("complete") || s.includes("closed") || s.includes("bill"))
    return { step: 4, label: "Delivered", tone: "ok" };
  if (s.includes("dispatch") || s.includes("transit") || s.includes("process"))
    return { step: 3, label: "Dispatched", tone: "navy" };
  if (s.includes("confirm") || s.includes("approv") || s.includes("accept"))
    return { step: 2, label: "Confirmed", tone: "navy" };
  return { step: 1, label: "Placed", tone: "navy" };
};
